import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./design/Inicio.css";
import "../App.css";
import BitacoraHoy from "./BitacoraHoy";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CrearCurso from "./CrearCurso";
import { faFileLines, faPlusCircle, faPenToSquare} from "@fortawesome/free-solid-svg-icons";
import { RoleGate } from './middleware/RoleGate.jsx';


function Inicio() {
    const [nombre, setNombre] = useState("");
    const [informaciones, setInformaciones] = useState([]);
    const [showBuscarSocio, setShowBuscarSocio] = useState(false);
    const [rut, setRut] = useState("");
    const [showModal, setShowModal] = useState(false);

    const navigate = useNavigate();


    useEffect(() => {
        const storedNombre = localStorage.getItem("nombreUsuario");
        if (storedNombre) {
            setNombre(storedNombre);
        }
    }, []);

    useEffect(() => {
        const fetchInformaciones = async () => {
            try {
                const res = await axios.get("http://192.168.1.81:5000/backend/api/informaciones");
                setInformaciones(res.data);
            } catch (error) {
                console.error("Error cargando informaciones:", error);
            }
        };

        fetchInformaciones();
    }, []);

    const handleBuscarSocio = () => {
        if (rut.trim() !== "") {
            setShowBuscarSocio(false); // cerrar modal
            navigate(`/ficha/${rut}`); // redirigir a ficha
        }
    };

    return (
        <div className="container mt-4">
            {/* Encabezado */}
            <header className="inicio-header" >
                <h3>Bienvenido, {nombre || "Usuario"}</h3>
            </header>

            {/* Contenido principal */}
            <main className="row inicio-main">
                {/* Bitácora y Accesos Directos */}
                <div className="col-12 col-md-12 col-lg-8">
                    <div className="card mb-3">
                        <div className="card-body bitacora">
                            <Link to="/bitacora" className="btn">
                                <h2 className="h2">Bitácora</h2>
                            </Link>
                            <BitacoraHoy />
                        </div>
                    </div>
                    <div className="card mb-3">
                        <div className="card-body">
                            <h2 className="card-title">Accesos Directos</h2>
                            <div className="row">
                                <RoleGate allowedRoles={["Administrador", "Digitador"]}>
                                <div className="col">
                                    <Button variant="light" onClick={() => navigate("/crear")}>  <FontAwesomeIcon icon={faPlusCircle} size="xl" /> Ingresar Nuevo Socio</Button>
                                </div>
                                </RoleGate>
                                <div className="col">
                                    <Button variant="light" onClick={() => setShowBuscarSocio(true)}>
                                        <FontAwesomeIcon icon={faFileLines} size="xl" /> Buscar Ficha por RUT
                                    </Button>
                                </div>
                                <RoleGate allowedRoles={["Administrador", "Digitador"]}>
                                <div className="col">
                                    <Button variant="light" onClick={() => setShowModal(true)}><FontAwesomeIcon icon={faPlusCircle} size="xl" /> Ingresar Nuevo Curso</Button>
                                </div>
                                </RoleGate>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Informaciones */}
                <div className="col-12 col-md-12 col-lg-4">
                    <div className="card mb-3">
                        <div className="card-body">
                            <h2 className="card-title">Informaciones
                            <RoleGate allowedRoles={["Administrador", "Secretario"]}>
                                <Link to="/informaciones" className="btn">
                                    <FontAwesomeIcon icon={faPenToSquare} size="lg" /> 
                                </Link>
                            </RoleGate>
                            </h2>

                            <ul className="list-group">
                                {informaciones.map((info) => (
                                    <li key={info.id} className="list-group-item">
                                        <h5>{info.titulo}</h5>
                                        <p>{info.contenido}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </main>

            {/* Modal Buscar Socio */}
            <Modal show={showBuscarSocio} onHide={() => setShowBuscarSocio(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Buscar Socio por RUT</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formRut">
                            <Form.Label>Ingrese RUT</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ej: 123456789"
                                value={rut}
                                onChange={(e) => setRut(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowBuscarSocio(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleBuscarSocio}>
                        Buscar
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <CrearCurso />
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default Inicio;
